import {createAction, props} from '@ngrx/store';
import {Sort} from '@angular/material/sort';
import {UsersActionTypes} from '@feature-module/user/redux/user.actions';
import {Paginable} from '@core/components/welfy-table/model/paginable-interface';
import {Collaborator} from '@feature-module/user/model/collaborator';
import {WelfareProject} from '@core/class/welfare-project';
import {PageEvent} from '@angular/material/paginator';

export enum SimulationActionsTypes {
  LOAD_PROJECTS = '[Simulation] Load Projects',
  LOAD_PROJECT = '[Simulation] Load Project',
  LOAD_PROJECTS_SUCCESS = '[Simulation] Load Projects success',
  LOAD_PROJECT_SUCCESS = '[Simulation] Load Project success',
  SAVE_PROJECT = '[Simulation] Save Projects',
  SAVE_PROJECT_SUCCESS = '[Simulation] Save Projects success',
  OPEN_PROJECT = '[Simulation] Open Project',
}
export const loadProjects = createAction(
  SimulationActionsTypes.LOAD_PROJECTS,
  props<{ sort?: Sort , pageEvent?: PageEvent}>()
);

export const loadProjectsSuccess = createAction(
  SimulationActionsTypes.LOAD_PROJECTS_SUCCESS,
  props<{ projects: Paginable<WelfareProject> }>()
);

export const saveProject = createAction(
  SimulationActionsTypes.SAVE_PROJECT,
  props<{ project: WelfareProject }>()
);

export const saveProjectSuccess = createAction(
  SimulationActionsTypes.SAVE_PROJECT_SUCCESS,
  props<{ project: WelfareProject }>()
);

export const loadProject = createAction(
  SimulationActionsTypes.LOAD_PROJECT,
  props<{ id: string}>()
);

export const loadProjectSuccess = createAction(
  SimulationActionsTypes.LOAD_PROJECT_SUCCESS,
  props<{ project: WelfareProject }>()
);

export const openProject = createAction(
  SimulationActionsTypes.OPEN_PROJECT,
  props<{ id: string}>()
);

